import React from 'react';

import { MobileFilter2 } from '../../../filter/MobileFilter2';
import { BathroomFilter } from '../../../../models/Filter';
import { BathroomNewFilterView } from '../../bathroom/BathroomNewFilter';

interface IBathroomFilter {
    filter: BathroomFilter;
    handleChange: (value: BathroomFilter) => void;
    classNameGroup?: string;
}

export const MobileBathroomFilterButtonView: React.FC<IBathroomFilter> = ({
    filter,
    handleChange,
    classNameGroup
}) => {
    return (
        <MobileFilter2 filterTitle='Санузел'>
            <BathroomNewFilterView
                filter={filter}
                handleChange={handleChange}
                classNameGroup={classNameGroup}
            />
        </MobileFilter2>
    );
};
